import { sensorTypeOptions, sensorWorkStatusOptions, yesNoOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { MainRowCustomerEmail } from "components/table/columnComponents/MainRowCustomerEmail"
import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { SensorSerialNumber } from "components/table/columnComponents/SensorSerialNumber"
import SensorsQuantity from "components/table/columnComponents/SensorsQuantity"
import { SensorWorkStatus } from "components/table/columnComponents/SensorWorkStatus"

const contractorColumn: UITypes.TableHeaderCell = {
  title: "Contractor",
  type: "sort-search",
  name: "contractor_name",
  size: "middle",
}

export const getSensorsTableHeaderCells = ({
  isVendor = false,
}: { isVendor?: boolean } = {}): UITypes.TableHeaderCell[] => [
  {
    title: "",
    name: "group_toggle",
    cellComponent: RowExpandToggle,
    size: "mini",
  },
  {
    title: "Thermostat / Sensor S/N",
    type: "sort-search",
    name: "sn",
    size: "middle",
    cellComponent: SensorSerialNumber,
  },
  {
    title: "Quantity",
    type: "sort-search-number",
    name: "sensor_count",
    size: "small",
    cellComponent: SensorsQuantity,
  },
  {
    title: "Type",
    type: "select",
    name: "sensor_type",
    size: "small",
    options: sensorTypeOptions,
  },
  ...(isVendor ? [contractorColumn] : []),
  {
    title: "Customer",
    type: "sort-search",
    name: "customer_name",
    size: "middle",
  },
  {
    title: "Customer Email",
    type: "sort-search",
    name: "customer_email",
    size: "large",
    cellComponent: isVendor ? undefined : MainRowCustomerEmail,
  },
  {
    title: "Installation Address",
    type: "sort-search",
    name: "installation_address",
    size: "large",
  },
  {
    title: "Work Status",
    type: "select",
    name: "work_status",
    size: "middle",
    options: sensorWorkStatusOptions,
    cellComponent: SensorWorkStatus,
  },
  {
    title: "Selected",
    type: "select",
    name: "selected_status",
    size: "small",
    options: yesNoOptions,
  },
]
